import { Observable, of } from 'rxjs';

import { Container, Service } from '../../../../symphony';

import { IActionData } from '../../global-interface';
import { SlCodeService } from '../Business/sl-code.service';
import { SlEventsService } from '../Business/sl-events.service';
import { SlCommonService } from '../Business/sl-common.service';
import { SlMaterialService } from '../Business/sl-material.service';
import { SlNewTrackingService } from '../Business/sl-new-tracking.service';
import { IMaterialInfo } from '../../../../api/private/learn-engine-api/learn-engine-api.interface';
import { ICodeCompilationResponse } from '../../../../api/public/code-api';
import { lePlaygroundContext } from '../../global-constants';

@Service()
export class SlActionsController {
	private commonService = Container.take(
		lePlaygroundContext.value,
		SlCommonService,
	);

	private eventsService = Container.take(
		lePlaygroundContext.value,
		SlEventsService,
	);

	private codeService = Container.take(lePlaygroundContext.value, SlCodeService);

	private materialService = Container.take(
		lePlaygroundContext.value,
		SlMaterialService,
	);

	private newTrackingService = Container.take(
		lePlaygroundContext.value,
		SlNewTrackingService,
	);

	public initPlaygroundHandler = ({
		topLevelDomain,
	}: IActionData): Observable<null> => this.commonService.initPlayground({
		topLevelDomain,
	});

	public getMaterialHandler = (
		data: IActionData,
	): Observable<IMaterialInfo> => this.materialService.getMaterial(data.materialId);

	public solveMaterialHandler = (
		data: IActionData,
	): void => this.materialService.solveMaterial(data.solveMaterialPayload);

	public onHeaderCompileBtnCLickHandler = (): Observable<ICodeCompilationResponse> => this.eventsService.onHeaderCompileCode();

	public onHeaderChangeModeToggleHandler = (
		data: IActionData,
	): Observable<null> => this.eventsService.onHeaderChangeModeToggle(data.state);

	public onMaterialNotFoundClickHandler = (): Observable<null> => this.eventsService.onMaterialNotFoundClick();

	public makeFreezeHandler = (): Observable<null> => this.commonService.makeFreeze();

	public resetContainerHandler = (): Observable<null> => this.commonService.resetContainer();

	public onCloseConsoleClickHandler = (): Observable<null> => this.eventsService.onCloseConsoleClick();

	public openConsoleHandler = (): Observable<null> => this.eventsService.openConsole();

	public onConsoleClickHandler = (): Observable<null> => this.eventsService.onConsoleClick();

	public onTrackActionHandler = ({
		trackData,
	}: IActionData): Observable<null> => {
		this.newTrackingService[trackData.actionName](trackData);
		return of(null);
	};

	public onCloseModalSaveBtnClickHandler = (): Observable<null> => this.eventsService.onCloseModalSaveBtnClick();

	public onCloseModalDiscardBtnClickHandler = (): Observable<null> => this.eventsService.onCloseModalDiscardBtnClick();
}
